import React, { Component } from "react";
import { LineChart, Line, XAxis, YAxis, CartesianGrid, Tooltip, Legend, ResponsiveContainer, ComposedChart, Bar } from "recharts";
import { CommonLoader } from "../../../common/CommonLoader";
import { formatAmount } from "../../../../services/utils";

class PaperStatsChartLineSiloCompare extends Component {

  getCurrentYearMonth() {
    const now = new Date();
    const year = now.getFullYear();
    const month = String(now.getMonth() + 1).padStart(2, '0'); // Ensure two digits
    return `${year}-${month}`;
  }

  formatDataColor = (data) => {
    const { activeTabTypeSilo } = this.props;
    const result = {};

    Object.values(data).forEach(monthData => {
      Object.values(monthData).forEach(silot => {
        const { silotId, silotName, color } = silot;

        if (!result[silotId]) {
          result[silotId] = {
            silotId,
            silotName,
            color,
          };
        }
      });
    });

    return result;

  };

  formatData = () => {
    const { data1, data2, year, frequency, activeTab, startMonth, endMonth } = this.props;

    const NbrInscrit = [];
    const Ca = [];

    if (frequency === "MONTHLY") {
      const monthNames = ["Jan", "Feb", "Mar", "Apr", "May", "Jun", "Jul", "Aug", "Sep", "Oct", "Nov", "Dec"];

      // Use current year's months to align previous year
      let allMonths = Object.keys(data1 || {}).sort();

      if (startMonth && endMonth) {
        allMonths = allMonths.filter(monthKey => {
          const [, month] = monthKey.split("-");
          return parseInt(month, 10) >= parseInt(startMonth, 10) &&
            parseInt(month, 10) <= parseInt(endMonth, 10);
        });
      }

      allMonths.forEach(monthKey => {
        const [year1, monthPart] = monthKey.split("-");
        const monthIndex = parseInt(monthPart, 10) - 1;

        // Previous year key (e.g., 2025-01 -> 2024-01)
        const prevYearKey = `${parseInt(year1) - 1}-${monthPart}`;

        const silots1 = data1[monthKey] || {};
        const silots2 = data2[prevYearKey] || {};

        const formattedMonth = monthNames[monthIndex];

        const nbrInscritObj = { name: formattedMonth };
        const caObj = { name: formattedMonth };

        let totalNbr1 = 0;
        let totalNbr2 = 0;
        let totalCa1 = 0;
        let totalCa2 = 0;

        // Merge silot names from both datasets
        const allSilotNames = Array.from(
          new Set([
            ...Object.values(silots1).map(s => s.silotName),
            ...Object.values(silots2).map(s => s.silotName),
          ])
        );

        allSilotNames.forEach(silotName => {
          const silot1 = Object.values(silots1).find(s => s.silotName === silotName);
          const silot2 = Object.values(silots2).find(s => s.silotName === silotName);

          const totalNbr1S = silot1
            ? (silot1.individuelNbrInscrit || 0) + (silot1.fiduciareNbrInscrit || 0)
            : 0;
          const totalCa1S = silot1
            ? (silot1.individuelCa || 0) + (silot1.fiduciareCa || 0)
            : 0;

          const totalNbr2S = silot2
            ? (silot2.individuelNbrInscrit || 0) + (silot2.fiduciareNbrInscrit || 0)
            : 0;
          const totalCa2S = silot2
            ? (silot2.individuelCa || 0) + (silot2.fiduciareCa || 0)
            : 0;

          // Add silot-specific values
          nbrInscritObj[`${silotName}_1`] = totalNbr1S;
          nbrInscritObj[`${silotName}_2`] = totalNbr2S;
          caObj[`${silotName}_1`] = totalCa1S / 100;
          caObj[`${silotName}_2`] = totalCa2S / 100;

          // Accumulate totals
          totalNbr1 += totalNbr1S;
          totalNbr2 += totalNbr2S;
          totalCa1 += totalCa1S;
          totalCa2 += totalCa2S;
        });

        // Add totals
        nbrInscritObj.Total1 = totalNbr1;
        nbrInscritObj.Total2 = totalNbr2;
        caObj.Total1 = totalCa1 / 100;
        caObj.Total2 = totalCa2 / 100;

        NbrInscrit.push(nbrInscritObj);
        Ca.push(caObj);
      });
    }



    if (frequency === "DAILY") {
      const monthNames = [
        "Jan", "Feb", "Mar", "Apr", "May", "Jun",
        "Jul", "Aug", "Sep", "Oct", "Nov", "Dec"
      ];

      const allDays = Object.keys(data1 || {}).sort();

      allDays.forEach(dayKey => {
        const [year1, monthPart, dayPart] = dayKey.split("-");
        const monthIndex = parseInt(monthPart, 10) - 1;

        // Previous year key (e.g., 2025-01-01 -> 2024-01-01)
        const prevYearKey = `${parseInt(year1) - 1}-${monthPart}-${dayPart}`;

        const silots1 = data1[dayKey] || {};
        const silots2 = data2[prevYearKey] || {};

        // Label like "01 Jan"
        const formattedDay = `${dayPart} ${monthNames[monthIndex]}`;

        const nbrInscritObj = { name: formattedDay };
        const caObj = { name: formattedDay };

        let totalNbr1 = 0;
        let totalNbr2 = 0;
        let totalCa1 = 0;
        let totalCa2 = 0;

        // Merge all silot names
        const allSilotNames = Array.from(
          new Set([
            ...Object.values(silots1).map(s => s.silotName),
            ...Object.values(silots2).map(s => s.silotName),
          ])
        );

        allSilotNames.forEach(silotName => {
          const silot1 = Object.values(silots1).find(s => s.silotName === silotName);
          const silot2 = Object.values(silots2).find(s => s.silotName === silotName);

          const totalNbr1S = silot1
            ? (silot1.individuelNbrInscrit || 0) + (silot1.fiduciareNbrInscrit || 0)
            : 0;
          const totalCa1S = silot1
            ? (silot1.individuelCa || 0) + (silot1.fiduciareCa || 0)
            : 0;

          const totalNbr2S = silot2
            ? (silot2.individuelNbrInscrit || 0) + (silot2.fiduciareNbrInscrit || 0)
            : 0;
          const totalCa2S = silot2
            ? (silot2.individuelCa || 0) + (silot2.fiduciareCa || 0)
            : 0;

          // Add silot-specific values
          nbrInscritObj[`${silotName}_1`] = totalNbr1S;
          nbrInscritObj[`${silotName}_2`] = totalNbr2S;
          caObj[`${silotName}_1`] = totalCa1S / 100;
          caObj[`${silotName}_2`] = totalCa2S / 100;

          // Accumulate totals
          totalNbr1 += totalNbr1S;
          totalNbr2 += totalNbr2S;
          totalCa1 += totalCa1S;
          totalCa2 += totalCa2S;
        });

        // Add totals
        nbrInscritObj.Total1 = totalNbr1;
        nbrInscritObj.Total2 = totalNbr2;
        caObj.Total1 = totalCa1 / 100;
        caObj.Total2 = totalCa2 / 100;

        NbrInscrit.push(nbrInscritObj);
        Ca.push(caObj);
      });
    }


    if (frequency === "YEARLY") {
      // ============================
    }

    return activeTab === "chiffreAffaire" ? Ca : NbrInscrit;

  };

  render() {
    const { visibleKeys, data1 } = this.props;
    const chartData = this.formatData();
    const coloredData = this.formatDataColor(data1);

    console.log('=== chartData ===', chartData);
    console.log('=== coloredData ===', coloredData);

    const legendPayload = [
      { value: 2025, type: 'line', color: '#000', id: 'Total1' },
      { value: 2024, type: 'line', color: '#464646b3', id: 'Total2' },
    ];

    return (
      <React.Fragment>
        {this.props.fetching ? <div style={{ width: '100%' }}><CommonLoader containerHeight={"300px"} iconFontSize={"50px"} iconColor={"#29394D"} /></div> : (
          <ResponsiveContainer width={'100%'} height={300}>
            <ComposedChart data={chartData} margin={{ top: 10, right: 30 }}>
              <CartesianGrid stroke="#D8DDE2" vertical={false} strokeDasharray="4" />
              <XAxis dataKey="name" tickMargin={10} axisLine={false} tickLine={false} tick={{ fill: '#6D7F92' }} />
              <YAxis tickMargin={10} axisLine={false} tickLine={false} tick={{ fill: '#6D7F92' }} allowDecimals={false} />
              <Tooltip content={({ active, payload, label }) => {
                if (active) {
                  return (
                    <div style={{
                      backgroundColor: '#ffffff',
                      padding: '10px',
                      borderRadius: '5px',
                      border: '1px solid gray'
                    }}>
                      <p>{label}</p>
                      {
                        payload && payload.filter(p => ["Total1", "Total2"].includes(p.dataKey)).map(p => (
                          <p key={p.dataKey}
                            style={{ color: p.stroke, fontSize: '14px' }}>
                            {legendPayload.find(legend => legend.id === p.dataKey).value}: {this.props.activeTab === 'chiffreAffaire' ? formatAmount(p.value, false) : p.value}
                          </p>
                        ))
                      }
                    </div>
                  );
                }
                return null;
              }} />
              <Legend payload={legendPayload} iconType="line" />
              {
                coloredData && Object.values(coloredData)
                  .map(silo => {
                    return visibleKeys.includes(silo.silotId) && (
                      <Bar dataKey={`${silo.silotName}_2`} stackId="b" fill={silo.color} name={`${silo.silotName} 2024`} opacity={0.5} />
                    );
                  })
              }
              {
                coloredData && Object.values(coloredData)
                  .map(silo => {
                    return visibleKeys.includes(silo.silotId) && (
                      <Bar dataKey={`${silo.silotName}_1`} stackId="a" fill={silo.color} name={`${silo.silotName} 2025`} />
                    );
                  })
              }
              <Line type="monotone" dataKey="Total1" stroke="#000" name="Total 2025" strokeWidth={2} isAnimationActive={true} animationDuration={2000} animationEasing="ease-out" />
              <Line type="monotone" dataKey="Total2" stroke="#464646b3" name="Total 2024" strokeWidth={2} isAnimationActive={true} animationDuration={2000} animationEasing="ease-out" />
            </ComposedChart>

          </ResponsiveContainer>
        )}
      </React.Fragment>
    );
  }
}

export default PaperStatsChartLineSiloCompare;



// WEBPACK FOOTER //
// ./app/components/Admin/EventStats/EventRegistrantLinechart/PaperStatsChartLineSiloCompare.js